import { render, staticRenderFns } from "./item-attachment.vue?vue&type=template&id=36dc4347&scoped=true"
import script from "./item-attachment.vue?vue&type=script&lang=js"
export * from "./item-attachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dc4347",
  null
  
)

export default component.exports